import * as Styled from './styled';
import { Props } from './types';

function Text({
  children,
  variant = 'b400',
  color = 'neutral',
  as,
  tag,
  ...rest
}: Props) {
  return (
    <Styled.Text variant={variant} $color={color} as={tag || as} {...rest}>
      {children}
    </Styled.Text>
  );
}

export default Text;
